<template>
    <v-container fluid class="py-0 my-0">
        <v-row style="background-color: teal;" class="my-0 py-0">
            <v-col cols="12" align="center">
                <div class="white--text" style="font-size: 50px; padding-left: 10px; margin: 0;">{{ league.title }}</div>
            </v-col>
        </v-row>
        <v-row class="mt-0 pt-0">
            <v-col cols="12" class="mx-0 px-0 mt-0 pt-0">
                <v-tabs
                    v-model="tab"
                    centered
                    class="rounded"
                    background-color="#232323"
                >
                    <v-tabs-slider class="custom-teal" />
                    <v-tab v-for="(item, index) in items" :key="index" style="font-size: 25px;">{{ item.name }}</v-tab>
                </v-tabs>
            </v-col>
        </v-row>
        <league-standings v-if="tab === 0" class="mt-5" :ranking="ranking" />
        <schedule-league v-else-if="tab === 1" :class="$vuetify.breakpoint.mobile ? '' : 'px-16'" :matches="matches" />
        <league-stats v-else-if="tab === 2" :class="$vuetify.breakpoint.mobile ? '' : 'px-16'" :league="league" :season="season.id" />
    </v-container>
</template>

<script>
    import ScheduleLeague from '@/components/ScheduleAlternative'
    import LeagueStats from '@/components/LeagueStats'
    import leagueService from '@/services/league'
    import LeagueStandings from '@/components/LeagueStandings'
    import matchService from '@/services/match'

    export default {
        components: { ScheduleLeague, LeagueStandings, LeagueStats },
        data() {
            return {
                tab: null,
                items: [
                    {
                        name: 'Standings'
                    },
                    {
                        name: 'Match Center'
                    },
                    {
                        name: 'Statistics'
                    }
                ],
                ranking: [],
                page: 1,
                size: 1000,
                totalPages: 0,
                matches: [],
                type: 'regular_season',
                matchTypes: ['regular_season', 'playoffs', 'cup'],
                seasonId: null,
                league: null,
                season: { id: 1 }
            }
        },
        watch: {
            '$route.params.id': {
                handler() {
                    this.getLeague(this.$route.params.id)
                    this.getRanking(this.$route.params.id)
                    this.fetchMatchesByLeague()
                }
            },
            type: {
                handler() {
                    this.getLeague(this.$route.params.id)
                    this.getRanking(this.$route.params.id)
                    this.fetchMatchesByLeague()
                }
            }
        },
        created() {
            this.getLeague(this.$route.params.id)
            this.getRanking(this.$route.params.id)
            this.fetchMatchesByLeague()
        },
        methods: {
            setType(option) {
                this.type = this.matchTypes[option]
            },
            getLeague(leagueId) {
                leagueService.getLeague(leagueId, this.type).then(resp => {
                    this.league = resp.data
                })
            },
            getRanking(leagueId) {
                leagueService.getRankingByLeague(leagueId, this.$store.getters.getConfig.activeSeasonId, this.$store.getters.getConfig.activePhase).then(resp => {
                    this.ranking = resp.data
                })
            },
            fetchMatchesByLeague() {
                matchService.getMatches(1, 100, { league: `{league: ${this.$route.params.id}}` }).then(resp => {
                    this.matches = resp.data.content
                }).catch(error => {
                    if (error.response.data.code === 'MATCH_NOT_FOUND') {
                        this.matches = []
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .mobile-sticky-banner {
        position: sticky;
        top: 80px;
        z-index: 1;
    }

    .pc-sticky-banner {
        position: sticky;
        top: 60px;
        z-index: 1;
    }

    .v-tab {
        text-transform: none !important;
        font-weight: bolder;
        font-size: 15px;
        color: #757578 !important;
    }

    .v-tab::before {
        opacity: 0;
        pointer-events: none;
        position: absolute;
        background-color: transparent;
    }
</style>
